<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getIsTipTapData } from '$lib/components/Blocks/_utils/getIsTipTapData';
    import { cn } from '$lib/utils/cn';

    import { getBoxAttributes } from '../_utils/getBoxAttributes';
    import { tipTapToHTML } from '../_utils/tiptapToHTML';
    import Box from '../_wrappers/Box.svelte';

    import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
    import type { Align } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect } from '$lib/types/Theme';
    import type { ExtensionConfig } from '../_utils/_extensions/types';
    import type { JSONContent } from '@tiptap/core';

    export let raw: JSONContent;
    export let color = 'black';
    export let align: Align = 'left';
    export let inheritSize = false;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let wide = false;
    export let noDesktopScaling = false;
    export let isInMediaAnswer = false;
    export let box: BoxType;
    export let layout = DEFAULT_LAYOUT;
    export let openLinksInNewTab = false;
    export let stopPropagationOfLinkClicks = false;
    export let extensionConfig: ExtensionConfig = {};

    let classes: string;

    const isInColumn = layout.isInColumn;

    const textBox: BoxType = getBoxAttributes({ box, isInColumn, isInMediaAnswer });

    // Force every link to be opened in a separate tab.
    if ((openLinksInNewTab || stopPropagationOfLinkClicks) && raw.entityMap) {
        for (const entityKey of Object.keys(raw.entityMap)) {
            const entity = raw.entityMap[entityKey];

            if (entity?.type === 'LINK') {
                if (openLinksInNewTab) {
                    entity.data.targetOption = '_blank';
                }

                if (stopPropagationOfLinkClicks) {
                    entity.data.stopPropagation = true;
                }
            }
        }
    }

    const html = getIsTipTapData(raw) ? tipTapToHTML(raw, inheritSize, extensionConfig) : '';

    $: classes = cn('wrapper', {
        'lg:fun-px-0': noDesktopScaling,
        'fun-text-left': align === 'left',
        'fun-text-center': align === 'center',
        'fun-text-right': align === 'right',
    });
</script>

<Box {...textBox} {transitionDelay} {transitionEffect} {wide}>
    <div class="fun-break-words {classes}" style="--textColor: {color}; --linkColor: {color};">
        {@html html}
    </div>
</Box>

<style lang="scss">
    .wrapper {
        // Empty paragraph behave like an <br> tag, required for TipTap
        // See: https://github.com/ueberdosis/tiptap/issues/412#issuecomment-593635371
        :global(p:empty::after) {
            content: '\00A0';
            // Default to Sans Serif as some custom fonts break the page when having special chars as content
            @apply fun-font-sans;
        }

        color: var(--textColor);
    }
</style>
